/**
 * Temporary control surface for Observation World environment studies.
 * Keep experiential constants here while visual decisions are still fluid.
 */
export const observationTuning = {
  camera: {
    fieldOfView: 42,
    dampingFactor: 0.055,
    panSpeed: 0.48,
    rotateSpeed: 0.48,
    zoomSpeed: 0.72,
    minimumDistanceInRadii: 0.16,
    maximumDistanceInFitDistances: 3.2,
  },
  lightingMotion: {
    intensityDepth: 0.3,
    driftDegrees: 15,
    cycleSeconds: 80,
  },
  world: {
    vector: [1, 0.14, -0.3] as const,
    orientationResponse: 0.24,
    restingTilt: [0.04, 0, -0.055] as const,
  },
  ambientField: {
    particleCount: 640,
    opacity: 0.42,
    speedMin: 0.14,
    speedMax: 0.42,
  },
  vectorGust: {
    particleCount: 96,
    maximumOpacity: 0.08,
    durationSeconds: 21,
    quietSeconds: 13,
    particleSizeInRadii: 0.13,
    widthInRadii: {
      min: 1.3,
      max: 2.2,
    },
    depthInRadii: 1.8,
  },
} as const;
